import { Container, Alert,Table, Modal, Button} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper} from "../ContentStyles";

import { FaFilePdf, FaReceipt, FaCamera, FaInfo, FaUser, FaShoppingBasket, FaStore} from 'react-icons/fa';
import React, {useMemo, useState, useEffect } from 'react';
import {useParams, useNavigate, useSearchParams} from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import useBackend, {CallAPI, Loading, SpinnerX} from '../../services/useBackend_v2';
import ReactPlayer from 'react-player';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions} from '../../services/misc';
import {ModalCustomerEdit} from './Customers'

import {Branding} from '../../services/misc';

export default function MyComponent() {
    const [modalshow,  setModalshow] = useState(false);
    const initModal = () => { return setModalshow(!modalshow) } 

    const [modalvideoshow,  setModalVideoshow] = useState(false);
    const initVideoModal = () => { return setModalVideoshow(!modalshow) }     

    const defaultValues              = {Customer: {}, Shop : {}, BasketItemList: []};
    const [selectedOrderData, setSelectedOrderData]    = useState(defaultValues);

    const navigate = useNavigate();

    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });

    const {loading, data, Refresh, XCall, Check, initReady, resultVisible, resultText, resultVariant} =  useBackend('/api/admin/orders2');
    const { loading: registerDataLoading, data: registerData } = useBackend(process.env.PUBLIC_URL + '/api/admin/Register');

    const orderRowClick = async (event, rowData)  =>  {
        //const OrderGUID = event.currentTarget.getAttribute("orderguid");
        // navigate("/orders/"+rowData.original.Guid);
        let { errorsException, jsondata } = await XCall('/api/admin/orders/'+rowData.original.Guid, "GET", 3000);

        setSelectedOrderData(jsondata)
        setModalshow(!modalshow);
    }

    async function closeAndRefresh() {
        setModalshow(false);
        Refresh();
    }    
    
    const orderDetailClick = (event)  =>  {
        const OrderGUID = event.currentTarget.getAttribute("orderguid");
        event.preventDefault();
        navigate("/orders/"+OrderGUID);
    }

    const customerDetailClick = (event)  =>  {
        const CustomerGUID = event.currentTarget.getAttribute("customerguid");
        //event.preventDefault();
        navigate("/customer/"+CustomerGUID);
    }    

    const showVideoClick = (event)  =>  {
        const OrderGUID = event.currentTarget.getAttribute("orderguid");
        console.log(OrderGUID);
        setModalVideoshow(!modalvideoshow);
        //event.preventDefault();
        //navigate("/customer/"+CustomerGUID);
    }      
    
    const columns = useMemo(() => [
        { size: 20, accessorKey: 'SerialNumber',   header: '#' },

        { size: 20, header: 'Tid'           , enableColumnActions: false,
            Cell: ({ row }) => ( <span>{DateTimeToLocal(row.original.Created)}</span> ),
        }, 
    
        { size: 20, header: 'Butik'           , enableColumnActions: true,
            Cell: ({ row }) => ( <span>{row.original.Shop.Name}/{row.original.Shop.Description}</span> ),
        },         

        { size: 20, header: 'Kund'           , enableColumnActions: false,
            Cell: ({ row }) => ( <span>{row.original.Customer.SSN}/{row.original.Customer.Name}</span> ),
        }, 
        { size: 10, accessorKey: 'StateText',  header: 'Status' },
        // { size: 20, header: 'Editera', columnDefType: 'display', enableColumnActions: false,            
        //     Cell: ({ row }) => ( <span style={{padding:5}} className='sub_' orderguid={row.original.Guid} onClick={orderClick} title="Info "><FaReceipt /></span> ),
        // },                   
      ]
    );
    
    const initialState = { 
        density: 'compact',
        columnVisibility: { Company: false, Kund:false, 'SerialNumber':false },
        pagination : { pageIndex: 0, pageSize: 25 }
    };

    useEffect(() => {
        //do something when the pagination state changes
        Refresh(pagination.pageIndex, pagination.pageSize);

        console.log('Page: ' + pagination.pageIndex);
        console.log('pageSize: ' + pagination.pageSize);
        
      }, [pagination.pageIndex, pagination.pageSize]);
    
    const state = { pagination };      

    if (initReady && !registerDataLoading) {
        return (
            <ContentWrapper>
                <ModalOrderEdit modalshow={modalshow} onHide={closeAndRefresh} OrderGuid={selectedOrderData.Guid} registerData={registerData}></ModalOrderEdit>

                <Modal show={modalvideoshow} onHide={initVideoModal}>
                  <Modal.Header closeButton>
                      <Modal.Title>{selectedOrderData.Shop.Description} ({selectedOrderData.SerialNumber})</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>                
                    <ReactPlayer className='react-player fixed-bottom_' width="100%" controls={true} url= {"https://www.nookshop.se/static/movie/"+selectedOrderData.Guid+".mp4"} />
                  
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="danger" onClick={initVideoModal}>Close</Button>
                  </Modal.Footer>
                </Modal>                

                <Container>
                    <Sida>                    
                        <MaterialReactTable 
                            enableColumnActions= {false}
                            columns={columns}
                            data={data.Orders}
                            manualPagination= {true}
                            paginationDisplayMode='pages'
                            rowCount= {data.totalNumOfRows}
                            onPaginationChange={setPagination} 
                            state={state}
                            muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                            muiTablePaginationProps={{ showFirstButton: true, showLastButton: true ,labelRowsPerPage:"Rader", rowsPerPageOptions: [25, 50, 100]}}
                            initialState={initialState}
                            renderTopToolbarCustomActions={() => (<Rubrik>Besök</Rubrik>)} 

                            muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {
                                    orderRowClick(event, row);
                                  //console.info(event, row.original.Guid);
                                },
                                sx: {
                                  cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                },
                                elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} 
                              })}
                        />                    
                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);         
    }
}


export function ModalOrderEdit(props) {
    const { loading, data, Refresh, resultVariant, resultVisible, resultText, resultSuccess, ReInit, Update, XCall, GUIDx } = useBackend('');
    const defaultValues              = {Customer: {Guid:null}, Shop : {Description:"", SerialNumber:"" }, BasketItemList: []};
    const [selectedOrderData, setSelectedOrderData]    = useState(defaultValues);
    const [editCustomerModalshow,  setEditCustomerModalshow] = useState(false);

    const navigate = useNavigate();

    async function closeForm() {
        setSelectedOrderData(defaultValues); 
        props.onHide();        
    }
    
    async function showForm() {                 
        let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI('/api/admin/orders/' + props.OrderGuid, "GET");        
        //setEditData(props.editCustomerData);
        setSelectedOrderData(jsondata);
    }

    const setOrderStateClick = async (event)  =>  {
        const NewState = event.currentTarget.getAttribute("newstate");
		await CallAPI('/api/admin/Orders/'+selectedOrderData.Guid,"PATCH","{\"NewOrderState\":\"10\"}");
        //Refresh(pagination.pageIndex, pagination.pageSize);
    }    

    function getOptions(object) {
        return object.map((key) => {
            return <option key={key.Id} value={key.Id}>{key.Name}</option>;
        });
    }

    return (
                <>
                <ModalCustomerEdit modalshow={editCustomerModalshow} onHide={() => {setEditCustomerModalshow(!editCustomerModalshow);}} CustomerGuid={selectedOrderData.Customer.Guid} registerData={props.registerData} ></ModalCustomerEdit>

                <Modal show={props.modalshow} onHide={() => closeForm()} onShow={() => showForm()}>
                    <Modal.Header closeButton>
                        <Modal.Title>{selectedOrderData.Shop.Description} ({selectedOrderData.SerialNumber})</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                    <Table  responsive="sm">
                        <tbody>
                            <tr><td>Butik</td><td colSpan={2}>{selectedOrderData.Shop.Name}/{selectedOrderData.Shop.Description}</td></tr>
                            <tr><td>Skapad</td><td colSpan={2}>{DateTimeToLocal(selectedOrderData.Created)}</td></tr>
                            <tr><td>Ordernr</td><td colSpan={2}>{selectedOrderData.SerialNumber}<br/><small>{selectedOrderData.Guid}</small></td></tr>
                            <tr>
                                <td>Kund</td><td>{selectedOrderData.Customer.Name}<br/>{selectedOrderData.Customer.SSN}<br/>{selectedOrderData.Customer.eMail} </td>
                                <td><Button variant="info" style={{width:"100px"}} onClick={() => {setEditCustomerModalshow(true);}}>Info</Button></td>
                            </tr>
                            <tr>
                                <td>Status</td><td colSpan={1}>{selectedOrderData.OrderStateText}</td>
                                <td>{selectedOrderData.OrderState!=5 && ( <Button variant="danger" style={{width:"100px"}} type="button" orderguid={selectedOrderData.Guid} onClick={setOrderStateClick} newstate="10">Makulera</Button> )}</td>
                            </tr>

                            <tr><td>Betalmetod</td><td colSpan={2}>{selectedOrderData.PaymentMethodText}<br/><small>{selectedOrderData.PaymentReference}</small></td></tr>

                        </tbody>
                    </Table>

                    <Table  responsive="sm">
                        <tbody>

                            <tr> <th>Name</th><th>Moms</th> <th>Antal</th>  <th>Pris</th> </tr>
                            {selectedOrderData.BasketItemList.map((item) => {
                                return <tr>
                                    <td>{item.Name}</td>
                                    <td>{item.Vat} %</td>
                                    <td>{item.Qty}</td>
                                    <td>{item.Price}</td>
                                </tr>
                            })}
                            <tr> <th>Totalt</th> <td colSpan={2}>{selectedOrderData.BasketTotalVat}</td> <td>{selectedOrderData.BasketTotalAmount}</td>   </tr>
                        </tbody>                        
                    </Table>                    
                 
                    </Modal.Body>
                    <Modal.Footer>
                        {/* <Button className="QmeButton"  style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="button" orderguid={selectedOrderData.Guid} onClick={orderDetailClick}><FaShoppingBasket/> Varukorg</Button> */}

                        {/* <Button className="QmeButton"  style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="button" customerguid={selectedOrderData.Customer.Guid} onClick={customerDetailClick}><FaUser/> Kundinformation</Button> */}

                        {/* <Button className={(selectedOrderData.HasVideo ? ("QmeButton"):("QmeButtonDisabled"))}   style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="button" orderguid={selectedOrderData.Guid} onClick={showVideoClick} disabled={!selectedOrderData.HasVideo}><FaCamera/></Button> */}

                        
                        <div style={{marginRight:"24px"}}>
                            <Button variant="danger" style={{width:"100px"}} onClick={closeForm}>Close</Button>
                        </div>
                    </Modal.Footer>
                </Modal>      
                </>
    );
}